import React from 'react';
import { Paper, Typography, Box } from '@mui/material';

function StatCard({ mainValue, subValue, title }) {
  return (
    <Paper sx={{ p: 2, height: '100%', textAlign: 'left' }}>
      <Typography variant="h6" sx={{ fontSize: '1.5rem', fontWeight: 'bold', mb: 0 }}>
        {mainValue}
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
        {subValue}
      </Typography>
      <Typography variant="caption" sx={{ color: 'text.secondary', textTransform: 'uppercase' }}>
        {title}
      </Typography>
    </Paper>
  );
}

export default StatCard;